import React from 'react';
import useFilters from '../../../hooks/useFilters';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import RankingsFilters from './RankingsFilters';
import RankingsListWrapper from './RankingsListWrapper';

const RankingsPage: React.FC = () => {

    const { filters, updateFilters, resetFilters } = useFilters({}, [], 1, 50, {});

    const breadCrumb = [
        { name: 'Ventas' },
        { name: 'Gestión de contratos' },
        { name: 'Rankings generales', href: menuRoutes.rankings.path },
    ];

    return (
        <>
            <PageHeader title="Rankings generales" breadcrumb={breadCrumb}>
            </PageHeader>
            <RankingsFilters
                filters={filters}
                updateFilters={updateFilters}
                resetFilters={resetFilters}
            />

            <RankingsListWrapper
                filters={filters}
                resetFilters={resetFilters}
            />
        </>
    );
};

export default RankingsPage;